import React from 'react';

const PublicHeader = () => <div></div>

export default PublicHeader;